module.exports = __webpack_public_path__ + "static/img/5.1.7e0bf08d.png";